export default {
  remote: 'simplify_hub_example_mfe',
  name: 'example',
  source: 'https://github.com/telus/simplify-mfe-example',
  urlMapping: {
    localhost: 'http://localhost:4322/mf-manifest.json',
    'simplify.developers.telus.digital': 'https://assets.wcpreview.telus.com/1100769639/simplify-example/v1/mf2/mf-manifest.json',
    'simplify.staging.developers.telus.digital': 'https://assets.wcstage.telus.com/1100769639/simplify-example/v1/mf2/mf-manifest.json',
    'simplify.telus.com': 'https://assets.telus.com/1100769639/simplify-example/v1/mf2/mf-manifest.json',
  },
};
